/**
 * Constants used throughout the project.
 *
 * Note: Most constants should remain localized to their relevant areas.
 * Only add constants here if they are truly cross-cutting and broadly applicable.
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get ADMIN_ROLES () {
        return ADMIN_ROLES;
    },
    get COMPANY_DEFAULT_DECIMAL_PLACES () {
        return COMPANY_DEFAULT_DECIMAL_PLACES;
    },
    get DEFAULT_REVIEW_CYCLE_DUE_TIME () {
        return DEFAULT_REVIEW_CYCLE_DUE_TIME;
    },
    get DEFAULT_REVIEW_START_TIME () {
        return DEFAULT_REVIEW_START_TIME;
    },
    get DEFAULT_TIMEZONE () {
        return DEFAULT_TIMEZONE;
    },
    get JSON_AI_STREAM_DELIMITER () {
        return JSON_AI_STREAM_DELIMITER;
    },
    get JSON_STREAM_DELIMITER () {
        return JSON_STREAM_DELIMITER;
    }
});
const DEFAULT_TIMEZONE = "America/New_York";
const JSON_STREAM_DELIMITER = "DELIM\n";
const JSON_AI_STREAM_DELIMITER = "\n";
const ADMIN_ROLES = [
    "billing-admin",
    "admin",
    "basic-admin"
];
const COMPANY_DEFAULT_DECIMAL_PLACES = 3;
const DEFAULT_REVIEW_START_TIME = 9;
const DEFAULT_REVIEW_CYCLE_DUE_TIME = 17;
